export const SEARCH_OPEN = 'SEARCH_OPEN';
export const SEARCH_CLOSE = 'SEARCH_CLOSE';
export const ADD_TO_CART = 'ADD_TO_CART';
export const CART_OPEN = 'CART_OPEN';
export const CART_CLOSE = 'CART_CLOSE';
export const CART_UPDATED = 'CART_UPDATED';
export const NAV_OPEN = 'NAV_OPEN';
export const NAV_CLOSED = 'NAV_CLOSED';
export const SET_COUNTRY = 'SET_COUNTRY';